import type { FaireProductEntity } from "../../entity_types/product";

export const p_hbmddnd5re: FaireProductEntity = {
  token: "p_hbmddnd5re",
  type: "product",
  name: "Golden Cider + Nutmeg - Clear Glass Tumbler Soy Candle",
  brandToken: "b_3sypsvzo",
  brandName: "Calyan Wax Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/6177ad3317cfdac1d3380af8843ea2662d86426b57dfe33362e9f14f27e3df6b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9e0a47dff9d7caeb60467dadf00651753f483bf64573f56ea062933c5e642820.jpeg",
    "https://cdn.faire.com/fastly/1241bd8cec87539bd01b98f3f0844f121427ab3dc350b721a5a9128bfc21a7e3.jpeg",
    "https://cdn.faire.com/fastly/5ae5ea9f0c4db3819785c8e4a64636a1e74cef9673a4ce3d6bc7705eca2ffcaf.jpeg",
    "https://cdn.faire.com/fastly/ebe71ee319f2642cfd3f61836cd5df8c1a4d2ead40166148d07089f61e44f64c.jpeg",
    "https://cdn.faire.com/fastly/8cf22ed3a62d14657955305e0bbc1d6976e52aca5acd2266ad52c56df1e792c3.jpeg",
    "https://cdn.faire.com/fastly/5c4a54b54d4a80339c35bf503e5035587435b4977f435a93025354313c81e8ba.jpeg",
  ],
  priceDollars: 14,
  description:
    "The ultimate fall candle—crisp autumn air, spicy nutmeg, and candied orange blend with mulled spices, smoldering leaves, vanilla bourbon, and fresh cedar for the perfect cozy autumn embrace.\n\nThis scented soy candle is made with fragrances infused with nutmeg, orange, cedarleaf, cade, and cedarwood essential oils.\n\nFeatures:\n• Reusable clear glass tumbler with tan label\n• Comes with a wooden bamboo lid to keep fragrance fresh and extend shelf life\n• 37 hours of long-lasting scent\n• We recommend this size for large living areas and bedrooms\n• Your purchase helps end human trafficking in the USA\n• Handcrafted by our magnificent team in Texas\n\nSimple Ingredients\n• 8.8 oz. natural soy wax\n• Phthalate-free fragrance oils infused with essential oils\n• 2 (two) metal-free cotton wicks\n\nScented Candle, Soy Candle, Jar, Aromatherapy, Decorative, Natural, Luxury, Home Fragrance, Essential Oil, Wedding Gift, Birthday Gift, Calming",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:02.470Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
